import { ejecutarExpresion } from '../motor/ejecutarExpresion.js'

export function reemplazarTextoPlano(xml, datos) {
  return xml.replace(/\$\{([^}]+)\}/g, (match, contenido) => {
    // 1️⃣ NO tocar imágenes
    if (contenido.startsWith('i:')) {
      // 👇 Mantener exactamente igual
      return match
    }

    try {
      // 2️⃣ Variables normales v:
      if (contenido.startsWith('v:')) {
        const valor = ejecutarExpresion(contenido, datos)
        return valor ?? ''
      }

      // 3️⃣ Funciones personalizadas
      if (/^[a-zA-Z0-9_]+:/.test(contenido)) {
        const valor = ejecutarExpresion(contenido, datos)
        return valor ?? ''
      }

      // 4️⃣ Placeholder desconocido → dejarlo igual
      return match
    } catch (e) {
      console.error('Error evaluando placeholder:', match, e)
      return match
    }
  })
}
